export default "__VITE_ASSET__C9GA9Q4B__"